import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, FormControlLabel, Switch, TextField, Typography } from '@mui/material';
import api from '../../api/api';

export default function LockerPointSettings({ pointId, value, onChange }) {
  const [cells, setCells] = useState([]);
  const [key, setKey] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let active = true;
    setKey(''); setCells([]); setError('');
    if (pointId) api.get(`/locker/points/${pointId}/cells`).then(r => {
      if (active) setCells(r.data);
    }).catch(() => { if (active) setError('Не удалось загрузить ячейки'); });
    return () => { active = false; };
  }, [pointId]);
  const generateKey = async () => {
    setBusy(true); setError('');
    try { const r = await api.post(`/locker/points/${pointId}/device-key`); setKey(r.data.device_key); }
    catch (e) { setError(e.response?.data?.detail || 'Не удалось создать ключ'); }
    finally { setBusy(false); }
  };
  const cancelPrepared = async operationId => {
    setBusy(true); setError('');
    try {
      await api.post(`/locker/points/${pointId}/operations/${operationId}/cancel`);
      setCells((await api.get(`/locker/points/${pointId}/cells`)).data);
    } catch (e) { setError(e.response?.data?.detail || 'Не удалось отменить подготовку'); }
    finally { setBusy(false); }
  };
  return <Box sx={{ border: '1px solid', borderColor: 'divider', p: 2, borderRadius: 2 }}>
    <FormControlLabel label="Есть ячейки (постамат)" control={<Switch checked={!!value.has_cells}
      onChange={e => onChange({ ...value, has_cells: e.target.checked, cell_count: e.target.checked ? value.cell_count || 8 : 0 })} />} />
    {value.has_cells && <>
      <TextField label="Количество ячеек" type="number" fullWidth margin="dense" inputProps={{ min: 1, max: 200 }}
        value={value.cell_count ?? 8} onChange={e => onChange({ ...value, cell_count: Number(e.target.value) })} />
      <Typography variant="body2" sx={{ my: 1 }}>Ячейки нумеруются от 1. Занятые ячейки отключить нельзя.</Typography>
      {pointId ? <>
        <Button disabled={busy} onClick={generateKey}>Создать / заменить ключ терминала</Button>
        {key && <Alert severity="success">Скопируйте ключ в настройки программы постамата. Предыдущий ключ больше не действует.
          <TextField fullWidth value={key} inputProps={{ readOnly: true, 'aria-label': 'Ключ терминала' }} sx={{ mt: 1 }} />
        </Alert>}
        {cells.map(c => <Box key={c.id} sx={{ mt: 1 }}>Ячейка {c.number}: {c.asset ? `${c.asset.name} (${c.asset.scan_code})` : 'свободна'}{c.operation_id ? ' · операция не завершена' : ''}
          {c.operation_state === 'prepared' && <Button disabled={busy} onClick={() => cancelPrepared(c.operation_id)}>Отменить подготовку</Button>}
        </Box>)}
      </> : <Typography variant="body2">Сохраните ПВЗ, затем откройте его для получения ключа терминала.</Typography>}
    </>}
    {error && <Alert severity="error">{error}</Alert>}
  </Box>;
}
